import classNames from 'classnames';
import { FlexContainer, ToDoHeading, Txt, View } from 'components';
import { observer } from 'mobx-react-lite';
import { useTenancy } from 'state';
import styles from './TenantsLinked.module.scss';

/**
 * TenantsLinked
 *
 * @return {JSX.Element}
 */
const TenantsLinked = ({ className }) => {
  const { data: tenancyData } = useTenancy();

  return (
    <FlexContainer
      className={classNames(
        styles.TenantsLinked,
        className,
        TenantsLinked.displayName
      )}
      column
      gap
    >
      <Txt bold>All tenants have linked 🎉</Txt>
      <ToDoHeading
        description1="LINKING"
        description2="Tenants linked"
        completed={tenancyData.tenantCount}
        completedOf={tenancyData.tenantUids.count}
        noDivider
        black
      />
      <View>
        <View>
          <Txt regular>Tenants will have access to:</Txt>
        </View>
        <View>
          <Txt regular>- Basic property details. </Txt>
        </View>
        <View>
          <Txt regular>- Basic property details. </Txt>
        </View>
        <View>
          <Txt regular>- Property certificates (EPC, EICR, Gas Safety).</Txt>{' '}
        </View>
        <View>
          <Txt regular>- GOV.UK Right to rent checklist.</Txt>
        </View>
        <View>
          <Txt regular>- Tenancy agreement. </Txt>
        </View>
        <View>
          <Txt regular>- Where rent and deposit payments should be sent. </Txt>
        </View>
        <View>
          <Txt regular>- Deposit details and certificate. </Txt>
        </View>
        <View>
          <Txt regular>- Messaging channel for the tenancy.</Txt>
        </View>
      </View>
    </FlexContainer>
  );
};

TenantsLinked.displayName = 'TenantsLinked';

export default observer(TenantsLinked);
